import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GivelifyColorPalette } from '@givelify/givelify-ui';
import {
    Accordion,
    Dialog,
    FormControlLabel,
    RadioGroup,
    styled,
} from '@mui/material';

const blueColor = '#cce2ef';

export const CheckmarkRadio = styled(FormControlLabel)({
    padding: '12px 24px',
    borderBottom: `1px solid ${GivelifyColorPalette.grey500}`,
    justifyContent: 'space-between',
    '& .MuiRadio-checked': {
        background: 'hotpink',
    },
    '& .MuiRadio-root': {
        order: 1,
        marginLeft: 'auto',
        padding: 0,
    },
    '&:last-child': {
        borderBottom: 0,
    },
});

export const CheckIcon = styled(FontAwesomeIcon)({
    fontSize: 14,
});

export const AccordionBlock = styled(Accordion)(({ theme }) => ({
    borderBottom: '2px solid ' + blueColor,
    boxShadow: 'none',
    '&.Mui-expanded': {
        margin: 0,
    },
    '& .MuiExpansionPanelSummary-root': {
        padding: theme.spacing(0, 2),
        '&.Mui-expanded': {
            minHeight: 0,
        },
        '& .MuiExpansionPanelSummary-content': {
            '&.Mui-expanded': {
                margin: '12px 0',
            },
        },
    },
    '& .MuiFormControlLabel-root': {
        marginLeft: 0,
        marginRight: 0,
    },
    '& .MuiExpansionPanelDetails-root': {
        padding: 0,
    },
    '& .MuiFormControlLabel-label': {
        fontSize: '14px',
    },
}));

export const ExpansionTitle = styled('div')({
    fontSize: '16px',
    fontWeight: 'bold',
});

export const RadioGroupBlock = styled(RadioGroup)({
    width: '100%',
});

export const DialogBlock = styled(Dialog)(({ theme }) => ({
    '& .MuiExpansionPanel-root:before': {
        opacity: 0,
    },
    [theme.breakpoints.down('sm')]: {
        '& .MuiDialog-scrollPaper': {
            alignItems: 'flex-end',
        },

        '& .MuiDialog-paperWidthSm': {
            maxWidth: '100%',
            width: '100%',
            margin: 'unset',
            height: 'calc(100vh - 50px)',
        },
    },
}));

export const Title = styled('h3')(({ theme }) => ({
    paddingLeft: theme.spacing(2),
    fontSize: '16px',
    fontWeight: 'bold',
}));

export const Divider = styled('hr')({
    border: '2px solid #D7EBF4',
    width: '100%',
    marginBottom: 'unset',
    marginTop: 'unset',
});
